<div class="modal-header border-0 p-0">
  <button
    type="button"
    class="btn em-btn p-0 ml-auto mr-2"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <i class="fal fa-times"></i>
  </button>
</div>

<div class="container flex-1 minh-0 d-flex flex-column p-0">
  <div class="grey-two-background justify-content-center items-container">
    <h6 class="modal-title text-uppercase text-center">
      {{ isEditMode ? 'Edit Credit' : 'Add Credit' }}
    </h6>
  </div>

  <form class="d-flex flex-column" [formGroup]="editForm" (ngSubmit)="onSubmit()">
    <!-- Discount/Promo Section -->
    <div class="row mt-3 order-1">
      <div class="col text-center">
        <label class="col-form-label text-uppercase bigger font-weight-bold text-right"> Apply Promo </label>
        <div class="toggle-container mb-2 d-flex justify-content-center align-items-center">
          <mat-button-toggle-group formControlName="discountMode" aria-label="Promo Type">
            <mat-button-toggle [value]="DiscountMode.None">None</mat-button-toggle>
            <mat-button-toggle [value]="DiscountMode.Discount">Discount</mat-button-toggle>
            <mat-button-toggle [value]="DiscountMode.Additional">Additional</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <div class="toggle-container mb-2 d-flex justify-content-center align-items-center">
          <mat-button-toggle-group formControlName="isPercentDiscount" aria-label="Promo Mode">
            <mat-button-toggle [value]="true">Percent</mat-button-toggle>
            <mat-button-toggle [value]="false">Dollar</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    </div>

    <!-- Credit Amount Section -->
    <div
      class="form-group row mt-3 credit-section"
      [ngClass]="{
        'order-2': !isSwapped,
        'order-4': isSwapped,
        swapping: isSwapping
      }"
    >
      <label for="creditAmount" class="col-6 col-form-label text-uppercase bigger font-weight-bold text-right">
        Credit Amount
      </label>
      <div class="col-6">
        <kendo-numerictextbox
          id="creditAmount"
          formControlName="creditAmount"
          [spinners]="false"
          [decimals]="2"
          [min]="0"
          [format]="'$#,##0.00'"
          [style.width.px]="150"
        ></kendo-numerictextbox>
      </div>
    </div>

    <!-- Promo Amount Section -->
    <div class="form-group row mt-3 order-3">
      <label for="discountValue" class="col-6 col-form-label text-uppercase bigger font-weight-bold text-right">
        Promo Amount
      </label>
      <div class="col-6">
        <kendo-numerictextbox
          id="discountValue"
          formControlName="discountValue"
          [spinners]="false"
          [decimals]="2"
          [min]="0"
          [format]="isPercentDiscount ? '#0.##\\%' : '$#,##0.00'"
          [style.width.px]="150"
          placeholder="0.00"
        ></kendo-numerictextbox>
      </div>
    </div>

    <!-- Total Amount Section -->
    <div
      class="form-group row mt-3 payment-section"
      [ngClass]="{
        'order-4': !isSwapped,
        'order-2': isSwapped,
        swapping: isSwapping
      }"
    >
      <label for="paymentAmount" class="col-6 col-form-label text-uppercase bigger font-weight-bold text-right">
        Payment Amount
      </label>
      <div class="col-6">
        <kendo-numerictextbox
          id="paymentAmount"
          formControlName="paymentAmount"
          [spinners]="false"
          [decimals]="2"
          [min]="0"
          [format]="'$#,##0.00'"
          [style.width.px]="150"
          placeholder="0.00"
        ></kendo-numerictextbox>
      </div>
    </div>

    <div class="row my-3 order-5">
      <div class="col text-center">
        <button [disabled]="!editForm.valid || !editForm.dirty" class="btn em-btn em-btn-green" type="submit">
          {{ isEditMode ? 'Update Credit' : 'Add Credit' }}
        </button>
      </div>
    </div>
  </form>
</div>
